<!-- col-md-6 col-lg-6 col-xl-4 -->
<footer class="footer_bg">
    <div class="container">
        <div class="row text-white text-center">
            <!-- <div class="col-md-4 col-lg-4 col-xl-4 footer_one"> -->
            <div class="col-xs-12 col-sm-6 footer_one">
                <h4 class="footer_title">yourDesiCart</h4>
                <p>84 High street, Kondapur <br> Hyderabad 500084</p>
                <p>Email: yourDesiCart@gmail.com</p>
                <p>Phone: +91 8328579397</p>

                <div class="footer-media-icon-images">
                    <span style="margin: 0px 5px 0px 0px">
                        <a itemprop="url" class="" href="https://www.facebook.com/yourDesiCart" target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa fa-facebook qodef-icon-element"
                                        style="color:#b2beb5;font-size:22px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class="" href="https://twitter.com/" target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa fa-twitter qodef-icon-element"
                                        style="color:#b2beb5;font-size:22px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class="" href="https://www.linkedin.com/" target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa fa-linkedin qodef-icon-element"
                                        style="color:#b2beb5;font-size:22px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class="" href="https://www.instagram.com/yourDesiCart" target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa fa-instagram qodef-icon-element"
                                        style="color:#b2beb5;font-size:22px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class="" href="https://in.pinterest.com/yourDesiCart/" target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa fa-pinterest qodef-icon-element"
                                        style="color:#b2beb5;font-size:22px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                    <span style="margin: 0px 5px 0px 5px">
                        <a itemprop="url" class="" href="https://www.youtube.com" target="_blank"
                            rel="noopener noreferrer">
                            <span class="flip-icon-holder">
                                <span class="icon-normal"><i
                                        class="qodef-icon-font-awesome fa fa-youtube-play qodef-icon-element"
                                        style="color:#b2beb5;font-size:22px"
                                        onMouseOver="this.style.color='rgb(0, 211, 243)'"
                                        onMouseOut="this.style.color='#ffffff'"></i></span>
                            </span>
                        </a>
                    </span>
                </div>
            </div>

            <div class="vertical-line" style="height: 200px;"></div>

            <!-- <div class="col-md-4 col-lg-4 col-xl-4 footer_two"> -->
            <div class="col-xs-12 col-sm-5 footer_two">
                <h4 class="footer_title">Quick Links</h4>
                <p (click)="provibited()">Prohibited
                    Items</p>
                    <p (click)="terms()">Terms of
                        Use</p>
                        <!-- <div style="padding: 10px;">
                            <div class="test_view_more_btn_container"
                                style="margin-top:-30px;">
                                <button class="test_view_more_btn" (click)="payment()">Payment</button>
                
                            </div>
                        </div> -->
            </div>
           
            <!-- <div class="vertical-line" style="height: 200px;"></div>

           
            <div class="col-xs-12 col-sm-3 footer_three">
                <h4 class="footer_title">Contact Us</h4>
                <p (click)="contactUs()">Contact Us</p>
            </div> -->
        </div>
    </div>
</footer>